import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import { BRAND } from "../lib/api";

// Google Maps embed centered on Montgomery, AL. No API key required for basic embed.
const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d215253.5!2d-86.4519!3d32.3668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus";

const CITIES = ["Montgomery", "Wetumpka", "Prattville", "Millbrook", "Pike Road", "Elmore"];

export default function ServiceMap() {
  return (
    <section
      id="area"
      data-testid="service-map"
      className="relative py-24 md:py-32 border-t border-brand-border overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="text-[11px] tracking-[0.3em] uppercase text-brand-muted mb-4 flex items-center gap-3">
            <span className="h-px w-8 bg-brand-blue" />
            07 — Service Area
          </div>
          <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight mb-6">
            Painters in <br />
            <span className="text-brand-blue">Central Alabama.</span>
          </h2>
          <p className="text-brand-muted text-base md:text-lg leading-relaxed mb-8">
            We serve homeowners and businesses across Montgomery and the
            surrounding River Region. If your project is within about 45
            minutes of downtown Montgomery, we&apos;re there.
          </p>

          <ul className="grid grid-cols-2 gap-2 mb-8">
            {CITIES.map((c) => (
              <li
                key={c}
                className="flex items-center gap-2 text-sm text-white/90"
              >
                <MapPin className="h-3.5 w-3.5 text-brand-blue" />
                {c}, AL
              </li>
            ))}
          </ul>

          <a
            href={BRAND.phoneHref}
            data-testid="area-call-btn"
            className="inline-flex items-center gap-3 bg-brand-blue hover:bg-brand-blueHover text-white px-6 py-4 font-display tracking-wider uppercase text-lg transition-colors"
          >
            <Phone className="h-5 w-5" />
            {BRAND.phone}
          </a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.6, 0.05, 0.15, 1] }}
          className="lg:col-span-8 relative"
        >
          <div className="relative w-full aspect-[4/3] md:aspect-[16/10] border border-brand-border bg-brand-surface overflow-hidden">
            <iframe
              src={MAP_SRC}
              title="RRR Paint & Construction service area — Montgomery, AL"
              width="100%"
              height="100%"
              style={{ border: 0, filter: "grayscale(1) invert(0.92) contrast(0.95)" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="pointer-events-none absolute top-4 left-4 bg-brand-blue text-white text-[10px] tracking-[0.3em] uppercase px-3 py-1 font-semibold">
              Central Alabama
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
